// IMP-388 W4 — "발급 현황" 탭 데이터 계층용 순수 헬퍼.

// companies 로 rootId 아래 모든 단계 하위 companyId 를 BFS 로 모은다. rootId 자신은 제외.
// 방문 Set 으로 순환(손상된 parentCompanyId)을 차단한다. 배열이 아니면 [].
export const collectDescendantCompanyIds = (companies, rootId) => {
    if (!Array.isArray(companies) || !rootId) return [];
    const childrenOf = new Map();
    companies.forEach((c) => {
        const cid = c?.companyId;
        const pid = c?.parentCompanyId;
        if (!cid || !pid) return;
        if (!childrenOf.has(pid)) childrenOf.set(pid, []);
        childrenOf.get(pid).push(cid);
    });
    const visited = new Set([rootId]);
    const result = [];
    const queue = [rootId];
    while (queue.length > 0) {
        const cur = queue.shift();
        const kids = childrenOf.get(cur) ?? [];
        kids.forEach((kid) => {
            if (visited.has(kid)) return;
            visited.add(kid);
            result.push(kid);
            queue.push(kid);
        });
    }
    return result;
};

// HQ 직속 조직 id — hqRootId 아래에서 어느 법인(isCorp 참) 서브트리에도 속하지 않는 조직(직속 딜러와 그 하위).
// 법인 노드를 만나면 그 노드도, 그 아래도 포함하지 않는다. hqRootId 자신은 제외. 방문 Set 으로 순환 차단.
export const collectHqDirectCompanyIds = (companies, hqRootId, isCorp) => {
    if (!Array.isArray(companies) || !hqRootId || typeof isCorp !== 'function') return [];
    const byId = new Map();
    const childrenOf = new Map();
    companies.forEach((c) => {
        const cid = c?.companyId;
        const pid = c?.parentCompanyId;
        if (!cid) return;
        byId.set(cid, c);
        if (!pid) return;
        if (!childrenOf.has(pid)) childrenOf.set(pid, []);
        childrenOf.get(pid).push(cid);
    });
    const visited = new Set([hqRootId]);
    const result = [];
    const queue = [hqRootId];
    while (queue.length > 0) {
        const cur = queue.shift();
        (childrenOf.get(cur) ?? []).forEach((kid) => {
            if (visited.has(kid)) return;
            visited.add(kid);
            if (isCorp(byId.get(kid))) return;
            result.push(kid);
            queue.push(kid);
        });
    }
    return result;
};

// 라이선스 귀속 조직 id — BE voucherLicense.js 의 귀속 축(dealerId 우선, 없으면 companyId)과 동일.
export const resolveLicenseOwnerId = (license) => license?.dealerId ?? license?.companyId ?? null;

// 동시 실행 상한(limit)을 지키며 fn 을 items 에 적용한다. 결과는 items 와 같은 순서.
// 개별 실패는 { ok:false, error } 로 남기고 전체를 멈추지 않는다(성공은 { ok:true, value }).
export const mapWithConcurrency = async (items, limit, fn) => {
    const list = Array.isArray(items) ? items : [];
    const results = new Array(list.length);
    const workers = Math.max(1, Math.min(Number.isFinite(limit) ? Math.floor(limit) : 1, list.length));
    let next = 0;
    const run = async () => {
        while (next < list.length) {
            const idx = next;
            next += 1;
            try {
                results[idx] = { ok: true, value: await fn(list[idx], idx) };
            } catch (error) {
                results[idx] = { ok: false, error };
            }
        }
    };
    await Promise.all(Array.from({ length: workers }, run));
    return results;
};
